import { tss } from "tss-react/mui"
import { alpha } from "@mui/material/styles"
import { IconButton } from "@mui/material"
import { faHeart } from "@fortawesome/pro-solid-svg-icons"
import { faHeart as faHeartBorder } from "@fortawesome/pro-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

type Placement = "top-left" | "top-right"

type StyleProps = Readonly<{ placement: Placement }>

const useStyles = tss.withParams<StyleProps>().create(({ theme, placement }) => ({
    button: {
        position: "absolute",
        top: ".75rem",
        left: placement === "top-left" ? ".75rem" : undefined,
        right: placement === "top-right" ? ".75rem" : undefined,
        padding: ".375rem",
        background: alpha(theme.palette.common.white, 0.5),
        color: theme.palette.tailwind.blue[600],
        zIndex: 2,
        transition: "all 0.3s ease-out",
        "&:hover": {
            background: theme.palette.common.white,
            color: theme.palette.tailwind.blue[800],
        },
    },
}))

type FavoriteButtonProps = Readonly<{
    isFavorite: boolean
    placement?: Placement
    onClick: () => void
}>

export function FavoriteButton({ isFavorite, placement = "top-right", onClick }: FavoriteButtonProps) {
    const { classes } = useStyles({ placement })

    return (
        <IconButton className={classes.button} size="small" onClick={onClick}>
            {isFavorite ? <FontAwesomeIcon icon={faHeart} /> : <FontAwesomeIcon icon={faHeartBorder} />}
        </IconButton>
    )
}
